/**
 * Shared UI fallback for runtime errors caught by Sentry boundary.
 * Keeps user messaging safe and branded without exposing raw stack traces.
 * Used by: Sentry ErrorBoundary in main entry.
 */
import BrandLogo from '../BrandLogo';

export default function AppErrorFallback() {
  return (
    <div className="wb-app-error" role="alert">
      <div className="wb-app-error__logo" aria-hidden="true">
        <BrandLogo className="wb-brand-logo wb-brand-logo--error" />
      </div>
      <h1>Something went wrong</h1>
      <p>The app hit an unexpected issue. Reload to continue.</p>
      <button className="wb-app-error__reload" onClick={() => window.location.reload()}>
        Reload app
      </button>
      <a href="mailto:support@workbill.in" className="wb-app-error__support">
        Contact support
      </a>
    </div>
  );
}
